import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperBuySocialPage } from './shopper-buy-social';

@NgModule({
  declarations: [
    ShopperBuySocialPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperBuySocialPage),
    TranslateModule.forChild()
  ],
})
export class ShopperBuySocialPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-social/shopper-buy-social.module.ts